import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { TagDesktop as Tag } from '@alfa-bank/site-tag/desktop';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';

import { RadioTags as Component } from '../radio-tags';
import type { IDepsDesktop, TRadioTagsDesktop } from '../models';
import { mapTagSizeToViewTextV2Desktop as mapTagSizeToViewTextV2 } from '../config';
import styles from '../styles/styles.css';

// className прокидывается через переменную classNames
// eslint-disable-next-line styler/check-styler
export const RadioTagsDesktop = createWidget<IDepsDesktop, TRadioTagsDesktop>({
    Tag,
    Text,
    styles,
    mapTagSizeToViewTextV2,
})(Component);
